import {
  backButton,
  initData,
  init as initSdk,
  isTMA,
  miniApp,
  setDebug,
  settingsButton,
  swipeBehavior,
  viewport,
} from "@telegram-apps/sdk-react";

export async function initMiniApp(debug = false) {
  if (!isTMA()) {
    console.info(
      "Skipping mini app initialization because it's not a Telegram Mini App",
    );
    return;
  }

  setDebug(debug);
  initSdk({ acceptCustomStyles: false });

  miniApp.mount();
  settingsButton.mount();
  backButton.mount();
  swipeBehavior.mount();
  initData.restore();
  void viewport
    .mount()
    .catch((e) => {
      console.warn("Something went wrong mounting the viewport", e);
    })
    .then(() => {
      viewport.bindCssVars();
    });
}
